// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__z6r2S","left":"StickyBox_left__y3Kj4","right":"StickyBox_right__6MY8h"};